import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditGroupComponent } from "./edit-group/edit-group.component";

@Component({
  selector: "app-internet-group",
  templateUrl: "./internet-group.component.html",
  styleUrls: ["./internet-group.component.scss"],
})
export class InternetGroupComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditGroupComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
